import { Grid, Typography, makeStyles, CircularProgress } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import noCertificate from 'assets/img/no-certificate.png';
import LessonList from './LessonList';
import { searchLessons } from 'services/searchLessons';
import { ILesson } from 'interface/course';
import { useParams } from 'react-router-dom';
import { toastError } from 'utils/reduxToast';
import { useGlobalSearch } from 'hooks/globalSearch';

const useStyles = makeStyles((theme) => ({
  container: {
    margin: 'auto',
    color: 'white',
  },
  title: {
    color: theme.palette.common.white,
    fontWeight: 600,
    fontSize: 20,
    [theme.breakpoints.down('md')]: {
      marginLeft: 20,
    },
  },
  description: {
    fontSize: 14,
    color: theme.palette.common.white,
    marginTop: 20,
    maxWidth: 400,
    textAlign: 'center',
  },
  fallbackImage: {
    maxWidth: 500,
    marginTop: 50,
    marginBottom: 50,
    margin: 'auto',
    display: 'block',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      padding: 50,
      marginTop: 50,
      marginBottom: 0,
    },
  },
  loader: {
    margin: '50px auto',
    display: 'block',
  },

}));

const SearchLessons: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [lessons, setLessons] = useState<ILesson[]>([]);
  const [page, setPage] = useState<number>(1);
  const { courseHash } = useParams<{ courseHash: string }>();
  const [endReached, setEndReached] = useState(false);
  const [search, setSearch] = useState('');
  const { searchText } = useGlobalSearch();

  const classes = useStyles();

  useEffect(() => {
    setSearch(null)
    setLessons([]);
    setEndReached(false);
    setPage(1);
    setSearch(searchText);
  }, [searchText]);

  useEffect(() => {
    if (!search || !courseHash || endReached) {
      return;
    }
    setLoading(true);
    searchLessons({ search, hash: courseHash, page })
      .then(({ data, total_pages }) => {
        setEndReached(total_pages <= 1 || page == total_pages);
        setLessons(l => [...l, ...data]);
      })
      .catch(() => toastError('Ocorreu um erro ao buscar as aulas'))
      .finally(() => {
        setLoading(false);
      });
  }, [page, search, endReached, courseHash]);

  const handleEndReached = () => {
    if (endReached) return;
    setPage((prev) => prev + 1);
  };

  if (!searchText?.length) {
    return null;
  }

  return (
    <>
      {lessons.length == 0 && !loading && (
        <Grid container direction='column' alignItems='center'>
          <Typography className={classes.title} id='searchLesson-empty'>
            Suas aulas aparecerão aqui...
          </Typography>
          <Typography className={classes.description}>
            Nenhuma aula encontrada, tente pesquisar outra coisa ou limpar a pesquisa.
          </Typography>
          <img src={noCertificate} alt='fallback' className={classes.fallbackImage} />
        </Grid>
      )}
      {
        <LessonList
          handleEndReached={handleEndReached}
          loading={loading}
          lessons={lessons}
        />
      }
      {loading && <CircularProgress size={45} color={'inherit'} className={classes.loader} />}
    </>
  );
};

export default SearchLessons;
